import React from "react";
import { NewTab, PageTab } from "../../../../../../components";
import InvoiceDetails from "./Invoices/InvoiceDetails";

const Invoices = ({ onCancel, currentPlacement, setActiveTab, editData }) => {
  const handleBack = () => {
    setActiveTab((prev) => prev + 1);
  };
  const InvoicesMenus = [
    {
      title: "Invoice Details",
      page: (
        <InvoiceDetails
          onCancel={onCancel}
          currentPlacement={currentPlacement}
          handleBack={handleBack}
          editData={editData}
        />
      ),
      type: "main",
    },
  ];
  return (
    // <div className="border-[1px] border-neutrals-50 rounded-b min-h-[69vh] overflow-auto">
    <div className="border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <NewTab
        tabs={InvoicesMenus}
        color="black"
        variant="text"
        activeVariant="text"
        mode="url"
        tabId="invoices"
      />
    </div>
  );
};

export default Invoices;
